<template>
  <div class="d-flex align-center flex-wrap" :class="{ 'justify-center': centered, 'justify-end': !centered }">
    <span class="body-2 mr-2 font-weight-medium" :style="{ color: textColor }">Visitas al Blog:</span>
    <v-icon v-for="(digit, i) in numberIcons" :key="i" :size="iconSize" :color="iconColor">
      {{ digit }}
    </v-icon>
  </div>
</template>

<script>
import forumService from '@/services/forumService.js';

export default {
  name: 'ContadorBlog',
  props: {
    textColor: { type: String, default: '#666' },
    iconColor: { type: String, default: 'teal' },
    iconSize: { type: [Number, String], default: 28 },
    centered: { type: Boolean, default: false }
  },
  data() {
    return {
      totalVisitas: 0
    };
  },
  computed: {
    numberIcons() {
      return String(this.totalVisitas).split('').map(digit => 'mdi-numeric-' + digit + '-box');
    }
  },
  mounted() {
    this.registrarVisita();
    this.obtenerConteo();
  },
  methods: {
    async registrarVisita() {
      try {
        await this.$recaptchaLoaded();
        const token = await this.$recaptcha('blog_visit');
        forumService.registrarBlogVisit({ recaptcha: token }).catch(() => {});
      } catch (e) {
        // Si recaptcha falla, no bloquear la experiencia
        console.log('Recaptcha no disponible para blog visit');
      }
    },
    obtenerConteo() {
      setTimeout(() => {
        forumService.getBlogVisitCount().then(res => {
          this.totalVisitas = res.data.cantidad || 0;
        }).catch(() => {});
      }, 1000);
    }
  }
};
</script>
